import type { IManClientDatingStatistic } from "types";
import requestWithAuth from "./httpClient";
import { rootURL } from "./rootURL";

const manClientAnalyticsURL = `${rootURL}man-client-analytics/get`;

export type ManClientAnalyticsResponse = {
	data: IManClientDatingStatistic[];
	meta: {
		total: number;
	};
};

export type ManClientAnalyticsParams = {
	startDate?: string;
	endDate?: string;
	manId?: string;
	clientName?: string;
	limit?: number;
	skip?: number;
	sortBy?: string;
};

export const getManClientAnalyticsRequest = (
	params: ManClientAnalyticsParams,
) => {
	const query = new URLSearchParams();
	if (params.startDate) query.append("startDate", params.startDate);
	if (params.endDate) query.append("endDate", params.endDate);
	if (params.manId) query.append("manId", params.manId);
	if (params.clientName) query.append("clientName", params.clientName);
	if (params.limit) query.append("limit", String(params.limit));
	if (params.skip) query.append("skip", String(params.skip));
	if (params.sortBy) query.append("sortBy", params.sortBy);

	return requestWithAuth<ManClientAnalyticsResponse>(
		"get",
		`${manClientAnalyticsURL}?${query.toString()}`,
	);
};
